import { useMemo } from 'react';

export const DOTS = '...';

const range = (start, end) => {
  let length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const usePagination = ({
  totalCount,
  pageSize,
  siblingCount = 1,
  currentPage,
  screen
}) => {
  const paginationRange = useMemo(() => {
    const totalPageCount = Math.ceil(totalCount / pageSize);

    // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
    const totalPageNumbers = screen === "large" ? siblingCount + 5 : siblingCount + 3;

    /*
      If the number of pages is less than the page numbers we want to show in our
      paginationComponent, we return the range [1..totalPageCount]
    */
    if (totalPageNumbers >= totalPageCount) {
      return range(1, totalPageCount);
    }

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(
      currentPage + siblingCount,
      totalPageCount
    );

    /*
      We do not want to show dots if there is only one position left 
      after/before the left/right page count as that would lead to a change if our Pagination
      component size which we do not want
    */
    const shouldShowLeftDots = screen === "large" ? leftSiblingIndex > 2 : leftSiblingIndex > 1;
    const shouldShowRightDots = screen === "large" ? rightSiblingIndex < totalPageCount - 2 : rightSiblingIndex < totalPageCount;

    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;

    if (!shouldShowLeftDots && shouldShowRightDots) {
      let leftItemCount = 3 + 2 * siblingCount;
      let leftRange = []
      if (screen === "large") {
        leftRange = range(1, leftItemCount);
      } else {
        leftRange = range(1, leftItemCount-2);
      }

      return [...leftRange, DOTS, totalPageCount];
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
      let rightItemCount = 3 + 2 * siblingCount;
      let rightRange= []
      if (screen === "large") {
        rightRange = range(
          totalPageCount - rightItemCount + 1,
          totalPageCount
        );
      } else {
        rightRange = range(
          totalPageCount - rightItemCount + 3,
          totalPageCount
        );
      }
      return [firstPageIndex, DOTS, ...rightRange];
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
      let middleRange= []
      if (screen === "large") {
        middleRange = range(leftSiblingIndex, rightSiblingIndex);
      } else {
        middleRange = range(leftSiblingIndex+1, rightSiblingIndex-1);
      }
      return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
    }
  }, [totalCount, pageSize, siblingCount, currentPage]);

  return paginationRange;
};
